function __dev() {
    let btn = document.querySelector('.__dev_mode_switch');
    if( btn ) {
        btn.onclick = function() {
            document.body.classList.toggle('__dev_mode');
        }
    }
    
}

__dev();